export default __webpack_public_path__ + "fonts/f0294a27f782ccb034dcf3ad7cee5cb3.svg";